import { useContext } from "react";
import { FeatureFlagsContext } from "./context";

export function useFeatureFlag() {
    const context = useContext(FeatureFlagsContext);

    if (!context) {
        throw new Error('useFeatureFlag must be used within the FeatureFlagsProvider');
    }

    return context;
}